export class PromotorCategoryAssignmentModel {
    public promotorCategoryAssignmentId?: number;
    public employeeId?: string;
    public promoterCategoryId?: number;
    public assignmentStartDate?: string;  // formato ISO
    public assignmentEndDate?: string | null;
    public assignmentReason?: string;
    public activeId?: boolean;
    public createUserId?: number;
    public createDate?: string;
    public modifUserId?: number;
    public modifDate?: string;
}
